import React from "react";
import { Col, Row } from "react-bootstrap";
import { GetBeforeAndAfterHitRanges } from "../Calculators/RangeSplitter";

const TestScaleDesign_1 = ({ item, isSub }) => {
  let elementScore = item?.normScore ? Number(item?.normScore) : item?.score;
  let splitRanges = GetBeforeAndAfterHitRanges(item?.scales);
  const filledPart =
    ((elementScore - splitRanges.hitRange?.start) / (splitRanges.hitRange?.end - splitRanges.hitRange?.start)) * 100;

  // Default colors matching Summary_L_Bar
  const progressColor = "#4a90e2";
  const backgroundColor = "#e0e0e0";

  return (
    <Row style={{ height: Number(item.height) }}>
      <div className="mb-3 mt-3">
        <Row>
          <Col className={"align-content-center"}>
            <Row>
              {splitRanges.beforeHitRangeList.map((range, i) => {
                return (
                  <Col
                    key={i + "-" + range.id + "scopeScale"}
                    className={"hit-scale-style-test-pdf p-0"}
                    style={{ height: "20px" }}
                  >
                    <div
                      style={{
                        height: "100%",
                        width: "100%",
                        backgroundColor: backgroundColor,
                        borderRadius: "8px",
                        overflow: "hidden",
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "10px",
                        fontWeight: "800",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          height: "100%",
                          width: "100%",
                          backgroundColor: progressColor,
                          borderRadius: "8px",
                        }}
                      />
                      <span style={{ position: "relative", zIndex: 1, color: "#fff" }}>{range.text}</span>
                    </div>
                  </Col>
                );
              })}
              <Col key={"hitScopeScale"} className={"hit-scale-style-test-pdf p-0"} style={{ height: "20px" }}>
                <div
                  style={{
                    height: "100%",
                    width: "100%",
                    backgroundColor: backgroundColor,
                    borderRadius: "8px",
                    overflow: "hidden",
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "10px",
                    fontWeight: "800",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      backgroundColor: progressColor,
                      borderRadius: "8px",
                    }}
                  />
                  <span style={{ position: "relative", zIndex: 1, color: "#fff" }}>{splitRanges.hitRange.text}</span>
                </div>
              </Col>

              {splitRanges.afterHitRangeList.map((range, i) => {
                return (
                  <Col
                    key={i + "-" + range.id + "scopeScale"}
                    className={"hit-scale-style-test-pdf p-0"}
                    style={{ height: "20px" }}
                  >
                    <div
                      style={{
                        height: "100%",
                        width: "100%",
                        backgroundColor: backgroundColor,
                        borderRadius: "8px",
                        overflow: "hidden",
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "10px",
                        fontWeight: "800",
                      }}
                    >
                      <span style={{ position: "relative", zIndex: 1, color: "#333" }}>{range.text}</span>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Row>
      </div>
    </Row>
  );
};
export default TestScaleDesign_1;
